<div class="table table-scroll" #tableReference>
  <table
    matSort
    mat-table
    matSortDisableClear
    [dataSource]="dataSource"
    (matSortChange)="sortChange($event)"
    [matSortActive]="_config.sortOn"
    [matSortDirection]="_config.sortOrder"
    [matSortDisabled]="!_config.sorting"
  >
    @for (column of columns; track column) {
    <ng-container [matColumnDef]="column['key']" [sticky]="column.isSticky">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [disabled]="!column.isSort"
        appTooltipEllipses
      >
        {{ column['label'] }}
        @if (column.tooltip) {
        <div
          class="info-icon"
          [matTooltipClass]="'customtooltip'"
          [matTooltipPosition]="'right'"
          matTooltip="{{ column.tooltip }}"
        >
          <img src="assets/images/roles/roleicon.svg" />
        </div>
        }
      </th>
      @if (!column.template) { @if (!column.type) {
      <td
        mat-cell
        *matCellDef="let element"
        class="{{ column.tdExtraClass || '' }}"
        appTooltipEllipses
      >
        {{ element[column['key']] }}
      </td>
      }
      <!-- For Type -->
      @if (column.type) { @if (column.type === 'date') {
      <td mat-cell *matCellDef="let element" appTooltipEllipses>
        {{ element[column['key']] | date : column.format || 'mediumDate' }}
      </td>
      } @if (column.type === 'status') {
      <td mat-cell *matCellDef="let element" appTooltipEllipses>
        {{ element[column['key']] ? 'Active' : 'Inactive' }}
      </td>
      } } }
      <!-- For Template -->
      @if (column.template) {
      <td
        mat-cell
        *matCellDef="let element"
        class="{{ column.tdExtraClass || '' }}"
        appTooltipEllipses
      >
        @if (column.template) {
        <ng-container
          [ngTemplateOutlet]="column.template"
          [ngTemplateOutletContext]="{
            data: element,
            field: column.key,
            column: column
          }"
        >
        </ng-container>
        }
      </td>
      }
    </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="columnKeys; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columnKeys"></tr>
  </table>
  @if (isLoader) {
  <div class="skeleton-container" aria-label="Loading…" aria-busy="true">
    @for (row of skeletonRows; track row) {
    <div class="skeleton-row">
      @for (col of columnKeys; track col) {
      <div class="skeleton-cell shimmer"></div>
      }
    </div>
    }
  </div>
  } @if ((!dataSource.data || dataSource.data.length === 0 || !dataSource) &&
  !isLoader) {
  <div class="no-data">
    <span class="no-data-text">{{ results }}</span>
  </div>
  }
</div>

@if (paginationData) {
<div class="pagination">
  <div class="total-items">
    <span class="count">{{ activePageSize }}</span>
    Items Per Page
  </div>
  @if (!paginationData.isTotalRecordsKnown) {
  <div>
    <button
      mat-icon-button
      [disabled]="paginationData.isFirstPage"
      class="text-violet"
      (click)="onPageChange(pageArrows.LEFT)"
    >
      <mat-icon
        [ngClass]="{
          'text-violet': !paginationData.isFirstPage,
          active: paginationData.isFirstPage
        }"
        >keyboard_arrow_left</mat-icon
      >
    </button>
    <button
      class="text-violet"
      mat-icon-button
      [disabled]="paginationData.isLastPage"
      (click)="onPageChange(pageArrows.RIGHT)"
    >
      <mat-icon
        [ngClass]="{
          'text-violet': !paginationData.isLastPage,
          active: paginationData.isLastPage
        }"
        >keyboard_arrow_right</mat-icon
      >
    </button>
  </div>
  }
  <div class="right">
    @if (paginationData.totalCount) {
    <div class="total-items">
      Total Items:
      <span class="count">
        {{ paginationData.totalCount | number }}
      </span>
    </div>
    }
  </div>
</div>
}
